<template>
  <canvas ref="chartCanvas"></canvas>
</template>

<script>
import { ref, onMounted, onUnmounted, watch } from 'vue';
import Chart from 'chart.js/auto';

export default {
  name: 'LineChart',
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const chartCanvas = ref(null);
    let chartInstance = null;

    const createChart = () => {
      if (chartInstance) {
        chartInstance.destroy();
      }

      if (chartCanvas.value && props.chartData) {
        const ctx = chartCanvas.value.getContext('2d');
        chartInstance = new Chart(ctx, {
          type: 'line',
          data: props.chartData,
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              datalabels: { display: false }, 
              legend: {
                position: 'top',
                rtl: true,
                labels: {
                  color: '#fff',
                  font: {
                    family: 'Vazir, Arial, sans-serif'
                  }
                }
              },
              tooltip: {
                rtl: true,
                titleFont: {
                  family: 'Vazir, Arial, sans-serif'
                },
                bodyFont: {
                  family: 'Vazir, Arial, sans-serif'
                },
                callbacks: {
                  label: function(context) {
                    return `${context.dataset.label}: ${new Intl.NumberFormat('fa-IR').format(context.parsed.y)}`;
                  }
                }
              }
            },
            scales: {
              x: {
                grid: {
                  color: 'rgba(255,255,255,0.12)'
                },
                ticks: {
                  color: '#fff',
                  font: {
                    family: 'Vazir, Arial, sans-serif'
                  }
                }
              },
              y: {
                grid: {
                  color: 'rgba(255,255,255,0.12)'
                },
                ticks: {
                  color: '#fff',
                  font: {
                    family: 'Vazir, Arial, sans-serif'
                  },
                  callback: function(value) {
                    return new Intl.NumberFormat('fa-IR').format(value);
                  }
                }
              }
            },
            ...props.options
          }
        });
      }
    };

    onMounted(() => {
      createChart();
    });

    onUnmounted(() => {
      if (chartInstance) {
        chartInstance.destroy();
      }
    });

    watch(() => props.chartData, () => {
      createChart();
    }, { deep: true });

    return {
      chartCanvas
    };
  }
};
</script>
